import { MACRO_LAYOUT_1 } from './macro0001';
import { MACRO_LAYOUT_2 } from './macro0002';

export const MACRO_LAYOUTS = [MACRO_LAYOUT_1, MACRO_LAYOUT_2];

export * from './macro0001';
export * from './macro0002';
